import React from 'react';

export const AppContainerContext = React.createContext<React.RefObject<HTMLDivElement> | undefined>({ current: null });
